import { skipToken } from '@apollo/client/react'
import UserFollowButton from 'src/components/UserFollowButton'
import type { Notification } from 'src/services/apollo/generated/graphql'
import { NotificationType } from 'src/services/apollo/generated/graphql'
import { useGetUserInfoById } from 'src/services/apollo/user'

export function NotificationActions(props: { item: Notification }) {
  const { type } = props.item
  if (type === NotificationType.Follow) {
    return <NotificationFollowAction item={props.item} />
  }
  return null
}

function NotificationFollowAction(props: { item: Notification }) {
  const { relatedUserIds } = props.item
  const { data: relatedUser } = useGetUserInfoById(
    relatedUserIds?.[0] ?? skipToken,
  )
  if (relatedUser) {
    return (
      <UserFollowButton
        user={relatedUser}
        userId={relatedUser.id}
        initialValue={relatedUser.followedByMe}
        initialFollowingMe={true}
        className="font-semibold text-xs text-white py-1 px-3"
        stateOverrides={{
          follow_back: {
            className: 'bg-purple-600',
            startIcon: null,
          },
          mutual: {
            className: 'bg-gray-400',
            variant: 'contained',
            startIcon: null,
          },
        }}
        disableUnfollow
        scene="notification"
      />
    )
  }
  return null
}
